import React from 'react';
import {Link} from 'react-router';
import imgResolver from '../utils/img-resolver';
import CurrentUserStore from '../stores/CurrentUserStore';

class AppHeader extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showUserDropdown: false,
        };
    }

    render () {
        const siteLogoClass = this.isNaviSelected('/offers/') || this.isNaviSelected('/dashboard/') ? 'active' : '';

        return (
            <header className="app-header">
                <div className="header-content-mobile">
                    {this.renderNavItems()}

                    <div className="user" onClick={this.toggleUserDropdown.bind(this)}>
                        <svg className="navi-icon" height="33" width="22" viewBox="0 0 22 33">
                            <path fill="#6b747e" fill-rule="evenodd" d="M 20 25.75 C 20 28.24 17.8 30.25 15.09 30.25 L 6.91 30.25 C 4.2 30.25 2 28.24 2 25.75 L 2 22.75 C 2 20.62 3.61 18.85 5.77 18.38 C 7.25 19.55 9.05 20.25 11 20.25 C 12.95 20.25 14.75 19.55 16.23 18.38 C 18.39 18.85 20 20.62 20 22.75 L 20 25.75 L 20 25.75 Z M 4 10.25 C 4 5.83 7.13 2.25 11 2.25 C 14.87 2.25 18 5.83 18 10.25 C 18 14.67 14.87 18.25 11 18.25 C 7.13 18.25 4 14.67 4 10.25 L 4 10.25 Z M 17.95 16.6 C 19.23 14.88 20 12.66 20 10.25 C 20 4.73 15.97 0.25 11 0.25 C 6.03 0.25 2 4.73 2 10.25 C 2 12.66 2.77 14.88 4.05 16.6 C 1.7 17.41 0 19.62 0 22.25 L 0 26.25 C 0 29.56 2.69 32.25 6 32.25 L 16 32.25 C 19.31 32.25 22 29.56 22 26.25 L 22 22.25 C 22 19.62 20.3 17.41 17.95 16.6 L 17.95 16.6 Z M 17.95 16.6" />
                        </svg>
                        <span>My Profile</span>
                        {this.renderUserDropdown()}
                    </div>
                </div>
                <div className="maxwidth-wrapper header-content-full">
                    <div className="left">
                        <Link to="agenda" className={siteLogoClass}><img className="site-logo" src={require('../styles/images/site-logo-small.svg')} alt="Gigpanel" /></Link>
                        {this.renderNavItems()}
                    </div>
                    <div className="right">
                        <div className="user" onClick={this.toggleUserDropdown.bind(this)}>
                            <span>{this.props.user.displayName}</span>
                            {this.renderUserDropdown()}
                        </div>
                    </div>
                </div>
            </header>
        );
    }

    renderNavItems() {
        if (this.props.isPro()) {
            return (
                <ul className="navi">
                    <li className={(this.isNaviSelected('/offers/') ? "active" : "") + " navi-offers"}>
                        <Link to="offers">
                            <svg className="navi-icon" height="33" width="29" viewBox="0 0 29 33">
                                <path fill="#6b747e" fill-rule="evenodd" d="M 2.08 11.58 L 2.08 11.58 L 2.08 11.58 L 6.43 29.03 C 6.7 30.11 7.78 30.76 8.85 30.5 L 21.47 27.35 C 22.54 27.08 23.19 26 22.92 24.92 L 18.57 7.47 C 18.3 6.39 17.22 5.74 16.15 6 L 3.53 9.15 C 2.46 9.42 1.81 10.5 2.08 11.58 L 2.08 11.58 Z M 0.14 12.06 C -0.4 9.92 0.9 7.74 3.05 7.21 L 15.66 4.06 C 17.81 3.53 19.98 4.83 20.51 6.98 L 24.86 24.44 C 25.4 26.58 24.1 28.76 21.95 29.29 L 9.34 32.44 C 7.19 32.97 5.02 31.67 4.49 29.52 L 0.14 12.06 L 0.14 12.06 Z M 0.14 12.06" />
                                <path fill="#ffffff" fill-rule="evenodd" d="M 8 4.26 C 8 2.04 9.79 0.25 12 0.25 L 25 0.25 C 27.21 0.25 29 2.04 29 4.26 L 29 22.24 C 29 24.46 27.21 26.25 25 26.25 L 12 26.25 C 9.79 26.25 8 24.46 8 22.24 L 8 4.26 Z M 8 4.26" />
                                <path fill="#6b747e" fill-rule="evenodd" d="M 10 4.26 L 10 4.26 L 10 22.24 C 10 23.36 10.89 24.25 12 24.25 L 25 24.25 C 26.1 24.25 27 23.35 27 22.24 L 27 4.26 C 27 3.14 26.11 2.25 25 2.25 L 12 2.25 C 10.9 2.25 10 3.15 10 4.26 L 10 4.26 Z M 8 4.26 C 8 2.04 9.79 0.25 12 0.25 L 25 0.25 C 27.21 0.25 29 2.04 29 4.26 L 29 22.24 C 29 24.46 27.21 26.25 25 26.25 L 12 26.25 C 9.79 26.25 8 24.46 8 22.24 L 8 4.26 L 8 4.26 Z M 8 4.26" />
                                <path fill="#6b747e" fill-rule="evenodd" d="M 14.5 8.25 L 22.5 8.25 C 23.05 8.25 23.5 7.8 23.5 7.25 C 23.5 6.7 23.05 6.25 22.5 6.25 L 14.5 6.25 C 13.95 6.25 13.5 6.7 13.5 7.25 C 13.5 7.8 13.95 8.25 14.5 8.25 L 14.5 8.25 Z M 14.5 8.25" />
                                <path fill="#6b747e" fill-rule="evenodd" d="M 14.5 13.25 L 22.5 13.25 C 23.05 13.25 23.5 12.8 23.5 12.25 C 23.5 11.7 23.05 11.25 22.5 11.25 L 14.5 11.25 C 13.95 11.25 13.5 11.7 13.5 12.25 C 13.5 12.8 13.95 13.25 14.5 13.25 L 14.5 13.25 Z M 14.5 13.25" />
                            </svg>
                            <span>Offers</span>
                        </Link>
                    </li>
                    <li className={(this.isNaviSelected('/myshifts/') ? "active" : "") + " navi-shifts"}>
                        <Link to="myshifts">
                            <svg className="navi-icon" height="31" width="33" viewBox="0 0 33 31">
                                <path fill="#6b747e" fill-rule="evenodd" d="M 30.76 13.25 L 2.76 13.25 L 2.76 8.25 C 2.76 7.15 3.65 6.25 4.76 6.25 L 28.76 6.25 C 29.86 6.25 30.76 7.15 30.76 8.25 L 30.76 13.25 L 30.76 13.25 Z M 14.76 16.25 C 14.76 15.88 14.86 15.55 15.03 15.25 L 18.48 15.25 C 18.65 15.55 18.76 15.88 18.76 16.25 C 18.76 17.35 17.86 18.25 16.76 18.25 C 15.65 18.25 14.76 17.35 14.76 16.25 L 14.76 16.25 Z M 30.76 26.25 C 30.76 27.35 29.86 28.25 28.76 28.25 L 4.76 28.25 C 3.65 28.25 2.76 27.35 2.76 26.25 L 2.76 15.25 L 12.9 15.25 C 12.81 15.57 12.76 15.9 12.76 16.25 C 12.76 18.46 14.55 20.25 16.76 20.25 C 18.97 20.25 20.76 18.46 20.76 16.25 C 20.76 15.9 20.7 15.57 20.61 15.25 L 30.76 15.25 L 30.76 26.25 L 30.76 26.25 Z M 12.76 3.25 C 12.76 2.7 13.2 2.25 13.76 2.25 L 19.76 2.25 C 20.31 2.25 20.76 2.7 20.76 3.25 L 20.76 4.25 L 12.76 4.25 L 12.76 3.25 L 12.76 3.25 Z M 28.76 4.25 L 22.76 4.25 L 22.76 2.25 C 22.76 1.15 21.86 0.25 20.76 0.25 L 12.76 0.25 C 11.65 0.25 10.76 1.15 10.76 2.25 L 10.76 4.25 L 4.76 4.25 C 2.55 4.25 0.76 6.04 0.76 8.25 L 0.76 26.25 C 0.76 28.46 2.55 30.25 4.76 30.25 L 28.76 30.25 C 30.97 30.25 32.76 28.46 32.76 26.25 L 32.76 8.25 C 32.76 6.04 30.97 4.25 28.76 4.25 L 28.76 4.25 Z M 28.76 4.25" />
                            </svg>
                            <span>My shifts</span>
                        </Link>
                    </li>
                </ul>
            );
        } else {
            return (
                <ul className="navi">
                    <li className={(this.isNaviSelected('/dashboard/') ? "active" : "") + " navi-agenda"}>
                        <Link to="agenda">
                            <svg className="navi-icon" height="33" width="29" viewBox="0 0 29 33">
                                <path fill="#6b747e" fill-rule="evenodd" d="M 2.08 11.58 L 2.08 11.58 L 2.08 11.58 L 6.43 29.03 C 6.7 30.11 7.78 30.76 8.85 30.5 L 21.47 27.35 C 22.54 27.08 23.19 26 22.92 24.92 L 18.57 7.47 C 18.3 6.39 17.22 5.74 16.15 6 L 3.53 9.15 C 2.46 9.42 1.81 10.5 2.08 11.58 L 2.08 11.58 Z M 0.14 12.06 C -0.4 9.92 0.9 7.74 3.05 7.21 L 15.66 4.06 C 17.81 3.53 19.98 4.83 20.51 6.98 L 24.86 24.44 C 25.4 26.58 24.1 28.76 21.95 29.29 L 9.34 32.44 C 7.19 32.97 5.02 31.67 4.49 29.52 L 0.14 12.06 L 0.14 12.06 Z M 0.14 12.06" />
                                <path fill="#ffffff" fill-rule="evenodd" d="M 8 4.26 C 8 2.04 9.79 0.25 12 0.25 L 25 0.25 C 27.21 0.25 29 2.04 29 4.26 L 29 22.24 C 29 24.46 27.21 26.25 25 26.25 L 12 26.25 C 9.79 26.25 8 24.46 8 22.24 L 8 4.26 Z M 8 4.26" />
                                <path fill="#6b747e" fill-rule="evenodd" d="M 10 4.26 L 10 4.26 L 10 22.24 C 10 23.36 10.89 24.25 12 24.25 L 25 24.25 C 26.1 24.25 27 23.35 27 22.24 L 27 4.26 C 27 3.14 26.11 2.25 25 2.25 L 12 2.25 C 10.9 2.25 10 3.15 10 4.26 L 10 4.26 Z M 8 4.26 C 8 2.04 9.79 0.25 12 0.25 L 25 0.25 C 27.21 0.25 29 2.04 29 4.26 L 29 22.24 C 29 24.46 27.21 26.25 25 26.25 L 12 26.25 C 9.79 26.25 8 24.46 8 22.24 L 8 4.26 L 8 4.26 Z M 8 4.26" />
                                <path fill="#6b747e" fill-rule="evenodd" d="M 14.5 8.25 L 22.5 8.25 C 23.05 8.25 23.5 7.8 23.5 7.25 C 23.5 6.7 23.05 6.25 22.5 6.25 L 14.5 6.25 C 13.95 6.25 13.5 6.7 13.5 7.25 C 13.5 7.8 13.95 8.25 14.5 8.25 L 14.5 8.25 Z M 14.5 8.25" />
                                <path fill="#6b747e" fill-rule="evenodd" d="M 14.5 13.25 L 22.5 13.25 C 23.05 13.25 23.5 12.8 23.5 12.25 C 23.5 11.7 23.05 11.25 22.5 11.25 L 14.5 11.25 C 13.95 11.25 13.5 11.7 13.5 12.25 C 13.5 12.8 13.95 13.25 14.5 13.25 L 14.5 13.25 Z M 14.5 13.25" />
                            </svg>
                            <span>Dashboard</span>
                        </Link>
                    </li>
                </ul>
            );
        }
    }

    isNaviSelected(path) {
        //return false; //broken
        if (process.env.BROWSER) {
            var routedPath = this.props.path.toString();
            return (routedPath === path || routedPath.substring(0, path.length + 1) === (path + "/")) //Second part checks if it starts with path/
        } else {
            return false;
        }
    }

    toggleUserDropdown() {
        this.setState({
            showUserDropdown: !this.state.showUserDropdown,
        });
    }

    onLogout() {
        this.toggleUserDropdown();
        CurrentUserStore.logout();
    }

    renderUserDropdown() {
        if (this.props.isPro()) {
            // This is not used right now. Keeping it for the sake of future.
            const billingLink = <li><Link to="/app/dashboard/billing">Billing</Link></li>;
            const ratingBlock = (
                <li className="pro-rating">Your rating:
                    <div className="stars">
                        <div className="star filled"></div>
                        <div className="star filled"></div>
                        <div className="star filled"></div>
                        <div className="star filled"></div>
                        <div className="star"></div>
                    </div>
                    <p>Your avarage rating is 4.3 out of 5.</p>
                </li>);

            return (
                <div onClick={this.dropdownClick} className={"user-dropdown" + (this.state.showUserDropdown ? " active" : "")}>
                    <ul>
                        <li><Link onClick={this.toggleUserDropdown.bind(this)} to="prosettingstab" params={{selectedTab: 1}}>Account settings</Link></li>
                        <li><Link onClick={this.toggleUserDropdown.bind(this)} to="prosettingstab" params={{selectedTab: 2}}>Notifications</Link></li>
                        {/*
                            Here should be
                            {billingLink}
                            {ratingBlock}
                        */}
                        <li><a onClick={this.onLogout.bind(this)} href="#">Log out</a></li>
                    </ul>
                </div>
            );
        } else {
            return (
                <div onClick={this.dropdownClick} className={"user-dropdown" + (this.state.showUserDropdown ? " active" : "")}>
                    <ul>
                        <li><Link onClick={this.toggleUserDropdown.bind(this)} to="settingstab" params={{selectedTab: 1}}>Account settings</Link></li>
                        <li><Link onClick={this.toggleUserDropdown.bind(this)} to="settingstab" params={{selectedTab: 3}}>Notifications</Link></li>
                        <li><Link onClick={this.toggleUserDropdown.bind(this)} to="settingstab" params={{selectedTab: 4}}>Your profile</Link></li>
                        <li><a onClick={this.onLogout.bind(this)} href="#">Log out</a></li>
                    </ul>
                </div>
            );
        }
    }

    dropdownClick(evt) {
        evt.stopPropagation(); //Prevents closing the dropdown by clicking inside of it
    }
}

AppHeader.propTypes = {
    path: React.PropTypes.string.isRequired
}

export default AppHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/AppHeader.js
 **/